import React, { useState, useRef, useEffect } from "react";
import { Form, message, Layout, Row, Col, Upload, Checkbox, Modal, Input, Select } from "antd";
import { useParams, useLocation } from "react-router-dom";
import { useMutation, useQuery, useLazyQuery } from "@apollo/client";
import { validationRegexAddress, validationRegexAmount, validationRegexMobileNo, validationRegexOnlyAlpha } from "../regex/regex";
import { Account_Form_Query, Role_Account_Query, Upload_Document, update_Account, Role_Management, Delete_Account, Delete_Job_Role, GET_ROLE_SPECIFIC_USERS_FOR_ROLE, GET_ADMIN_USERS_FOR_ROLES } from "../services/userAPI";
import TextInputField from "../reusableField/TextInputField2";
import "./createClient.css";
import { SketchPicker } from "react-color";
import { useNavigate } from "react-router-dom";
import CreateClientImage from "../Images/createClientImage.png";
import AddRoleIcon from "../Images/Add_Role_icon.png";
import { Radio } from "antd";
import DeleteButton from "../Images/deleteButton-icon.png";
import { Pencil } from "lucide-react";


const { Content } = Layout;
const pencilCursor = `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjUgMy41TDIwLjUgNy41TTE2LjUgMy41TDQuNSAxNS41TDMuNSAyMC41TDguNSAxOS41TDIwLjUgNy41TTE2LjUgMy41WiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+`;

const CreateClient = () => {
    const { id } = useParams();
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const location = useLocation();
    const accountId = id || location.state?.id;
    const [isPickingColor, setIsPickingColor] = useState(false);
    const { projectsData: passedProjectsData } = location.state || {};
    const [uploadedFilename, setUploadedFilename] = useState(null);
    const [color, setColor] = useState("FFAD01");
    const [selectedColor, setSelectedColor] = useState(null);
    const canvasRef = useRef(null);
    const [showPicker, setShowPicker] = useState(false);
    const [clientImage, setClientImage] = useState(null);
    const [isFormValid, setIsFormValid] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [role, setRole] = useState([]);
    const [form] = Form.useForm();
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});
    const [isEditMode, setIsEditMode] = useState(false);
    const [editingRoleId, setEditingRoleId] = useState(null);
    const imageRef = useRef(null);
    const [isToggled, setIsToggled] = useState(() => Boolean(location.state?.selfRegistration));
    const [showdeleteJobRoleModal, setShowDeleteJobRoleModal] = useState(false);
    const [showdeleteAccountModal, setShowDeleteAccountModal] = useState(false);
    const [selectedRoleId, setSelectedRoleId] = useState(null);
    const [deleteType, setDeleteType] = useState(null);
    const [formData, setFormData] = useState({
        id: location.state?.id || "",
        name: location.state?.name || "",
        imageUrl: location.state?.imageUrl || "",
        mainLogoUrl: location.state?.mainLogoUrl || "",
        address: location.state?.address || "",
        role: location.state?.role || "",
        companyURL: location.state?.url || "",
        address2: location.state?.address2 || "",
        roles: [],
        selfRegistration: location.state?.selfRegistration || false,
        brandColor: location.state?.brandColor || "FFAD01",
        mandatoryTimeDistribution: false,
        dartsForm: false,
        filename: "",
        imageUrl: "",
        assignedUsersForClient: location.state?.assignedAdmin || [],
        jobroleAccessUserIds: [...(location.state?.roleAdmin || []), ...(location.state?.clanCrew || [])],
        roleAdmin: [],
        clanCrew: [],
        signInSignOutRequired: null,
        locationRequired: null,
        ldmsNeeded: null,
        mirrorNeeded: null,
        geoTracking: false,
        sync: location.state?.syncNeeded || false,
    });

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const validationRegexOnlyAlphaAddRole = /^[a-zA-Z\s]{2,120}$/;
    const validationRegexMobileNoAddRole = /^[6-9]\d{9}$/;
    const emailRegexAddRole = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const urlRegex = /^(https:\/\/|www\.)[a-zA-Z0-9\-]+(\.[a-zA-Z0-9\-]+)*(\.[a-zA-Z]{2,})(:[0-9]+)?(\/[a-zA-Z0-9\-_#=&\/?]*)?$/;

    const customStyles = `
    .pencil-cursor {
      cursor: url(${pencilCursor}) 0 24, auto !important;
    }
  `;

    const normalizeColor = (inputColor) => {
        return (typeof inputColor === "string" && inputColor.startsWith("#"))
            ? inputColor.toUpperCase()
            : `#${(inputColor || '').toUpperCase()}`;
    };

    const handleColorClick = () => {
        setShowPicker(prevState => !prevState);
    };

    const handleColorChange = (selectedColor) => {
        const newColor = selectedColor.hex;
        setColor(newColor);
        setFormData(prevData => ({
            ...prevData,
            brandColor: newColor
        }));
    };

    const initializeCanvas = () => {
        if (!imageRef.current) return;
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const img = imageRef.current;
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        ctx.drawImage(img, 0, 0);
        canvasRef.current = canvas;
    };

    const handleMouseMove = (e) => {
        if (!isPickingColor || !imageRef.current || !canvasRef.current) return;
        const img = imageRef.current;
        const rect = img.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const scaleX = img.naturalWidth / img.width;
        const scaleY = img.naturalHeight / img.height;
        const actualX = Math.floor(x * scaleX);
        const actualY = Math.floor(y * scaleY);
        const ctx = canvasRef.current.getContext('2d');
        const pixelData = ctx.getImageData(actualX, actualY, 1, 1).data;
        const rgb = `rgb(${pixelData[0]}, ${pixelData[1]}, ${pixelData[2]})`;
        const hex = `#${pixelData[0].toString(16).padStart(2, '0')}${pixelData[1].toString(16).padStart(2, '0')}${pixelData[2].toString(16).padStart(2, '0')}`;
        setPosition({ x, y });
        setSelectedColor({ rgb, hex });
        setColor(hex);
        setFormData(prevData => ({ ...prevData, brandColor: hex }));
    };

    const startColorPicking = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsPickingColor(true);
        initializeCanvas();
        if (imageRef.current) {
            imageRef.current.classList.add('color-picking-cursor');
            imageRef.current.classList.add('active-picker-border');
        }
    };

    const handleImageClick = (e) => {
        if (!isPickingColor) return;
        e.preventDefault();
        e.stopPropagation();
        if (selectedColor) {
            setFormData(prevData => ({
                ...prevData,
                brandColor: selectedColor.hex
            }));
        }
        setIsPickingColor(false);
        if (imageRef.current) {
            imageRef.current.classList.remove('color-picking-cursor');
            imageRef.current.classList.remove('active-picker-border');
        }
    };

    const { data: rolesData, loading: rolesLoading, error: rolesError, refetch: refetchRoles } = useQuery(Role_Account_Query, {
        variables: { accountId: parseInt(accountId) },
        skip: !accountId,
    });

    const [fetchRoleSpecificUsers] = useLazyQuery(GET_ROLE_SPECIFIC_USERS_FOR_ROLE);

    const showModal = () => {
        setIsModalVisible(true);
        setIsEditMode(false);
        setEditingRoleId(null);
        setFormData(prev => ({
            ...prev,
            lense: false,
            darts: false,
            clan: false,
            numberLogin: false,
            emailLogin: false,
            roleAdmin: [],
            clanCrew: [],
            jobroleAccessUserIds: [],
            signInSignOutRequired: null, // Reset to null for new roles
            locationRequired: null, // Reset to null for new roles
            ldmsNeeded: null, // Reset to null for new roles
            mirrorNeeded: null,
        }));
        form.resetFields();
    };

    const roleManagementHandleCheckboxChange = (name) => {
        setFormData((prev) => {
            const updatedData = { ...prev, [name]: !prev[name] };
            form.validateFields(['productAccess']);
            return updatedData;
        });
    };

    // Separate queries for each dropdown
    const { data: assignedAdminData, loading: assignedAdminLoading, error: assignedAdminError } = useQuery(GET_ADMIN_USERS_FOR_ROLES, {
        variables: {
            roleName: "admin",
            searchString: null,
            pagingCriteria: { limit: 50, cursor: null, sortByField: "created_at", sortOrder: "desc" },
        },
    });

    const { data: roleAdminData, loading: roleAdminLoading, error: roleAdminError } = useQuery(GET_ADMIN_USERS_FOR_ROLES, {
        variables: {
            roleName: "role admin",
            searchString: null,
            pagingCriteria: { limit: 50, cursor: null, sortByField: "created_at", sortOrder: "desc" },
        },
    });

    const { data: clanCrewData, loading: clanCrewLoading, error: clanCrewError } = useQuery(GET_ADMIN_USERS_FOR_ROLES, {
        variables: {
            roleName: "clan crew",
            searchString: null,
            pagingCriteria: { limit: 50, cursor: null, sortByField: "created_at", sortOrder: "desc" },
        },
    });

    // Options for each dropdown
    const assignedAdminOptions = assignedAdminData?.getAdminUsersForRoles?.data?.map(admin => ({
        value: admin.id,
        label: `${admin.firstName} ${admin.surname || ''} (${admin.email})`,
    })) || [];

    const roleAdminOptions = roleAdminData?.getAdminUsersForRoles?.data?.map(admin => ({
        value: admin.id,
        label: `${admin.firstName} ${admin.surname || ''} (${admin.email})`,
    })) || [];

    const clanCrewOptions = clanCrewData?.getAdminUsersForRoles?.data?.map(admin => ({
        value: admin.id,
        label: `${admin.firstName} ${admin.surname || ''} (${admin.email})`,
    })) || [];

    const [addJobrole, { loading: addRoleLoading }] = useMutation(Role_Management, {
        onCompleted: (data) => {
            if (data.addJobrole.success) {
                message.success(isEditMode ? "Role updated successfully!" : "Role added successfully!");
                handleCancel();
                refetchRoles();
            } else {
                message.error(data.addJobrole.message || "Failed to update role");
            }
        },
        onError: (error) => {
            message.error("Something went wrong: " + error.message);
        },
    });

    useEffect(() => {
        setRole(rolesData?.getAllJobrole || []);
    }, [rolesData]);

    const addJobRoleHandleSubmit = async () => {
        try {
            const values = await form.validateFields();
            if (!formData.lense && !formData.darts && !formData.clan && !formData.sync) {
                message.error("Please select at least one product access");
                return;
            }
            if ((formData.darts || formData.clan) && !formData.numberLogin && !formData.emailLogin) {
                message.error("Please select a login method when Darts or Clan is selected!");
                return;
            }

            // Additional validation
            if (!accountId) {
                message.error("Account ID is missing!");
                return;
            }
            if (!values["role name"] || !values["POC name"] || !values["email"] || !values["contact no"]) {
                message.error("All form fields are required!");
                return;
            }
            if (!emailRegexAddRole.test(values["email"])) {
                message.error("Please enter a valid email address!");
                return;
            }
            if (!validationRegexMobileNoAddRole.test(values["contact no"])) {
                message.error("Please enter a valid mobile number!");
                return;
            }

            // Check for duplicate role name (for new roles)
            const existingRoles = rolesData?.getAllJobrole || [];
            if (!isEditMode && existingRoles.some(role => role.name === values["role name"])) {
                message.error("Role name already exists");
                return;
            }

            const roleAdminIds = formData.roleAdmin || [];
            const clanCrewIds = formData.clanCrew || [];
            const jobroleAccessUserIds = [...new Set([...roleAdminIds, ...clanCrewIds])];

            const newRole = {
                accountId: parseInt(accountId),
                name: values["role name"],
                clanNeeded: formData.clan || false,
                syncNeeded: formData.sync || false,
                dartsNeeded: formData.darts || false,
                dartsFormNeeded: false,
                pocName: values["POC name"],
                pocEmail: values["email"],
                pocNumber: values["contact no"],
                numberLogin: formData.numberLogin || false,
                emailLogin: formData.emailLogin || false,
                mandatoryTimeDistribution: false,
                targetEditDays: 0,
                inputEditDays: 0,
                jobroleAccessUserIds: jobroleAccessUserIds,
                // For create: send false; for edit: send API-provided values
                signInSignOutRequired: isEditMode ? formData.signInSignOutRequired : false,
                locationRequired: isEditMode ? formData.locationRequired : false,
                ldmsNeeded: isEditMode ? formData.ldmsNeeded : false,
                mirrorNeeded: isEditMode ? formData.mirrorNeeded : false,
                geoTracking: isEditMode ? formData.geoTracking : false,
            };

            console.log("Mutation Variables:", newRole); // Debug payload

            let response;
            if (isEditMode) {
                response = await addJobrole({
                    variables: {
                        ...newRole,
                        jobroleId: parseInt(editingRoleId),
                    },
                });
            } else {
                response = await addJobrole({
                    variables: newRole,
                });
            }

            if (response?.data?.addJobrole?.success) {
                // message.success(isEditMode ? "Role updated successfully!" : "Role added successfully!");
                setIsModalVisible(false);
                setFormData((prevData) => ({
                    ...prevData,
                    lense: false,
                    darts: false,
                    clan: false,
                    numberLogin: false,
                    emailLogin: false,
                    roleAdmin: [],
                    clanCrew: [],
                    jobroleAccessUserIds: [],
                    signInSignOutRequired: null,
                    locationRequired: null,
                    ldmsNeeded: null,
                    mirrorNeeded: null,
                }));
                form.resetFields();
                setIsEditMode(false);
                setEditingRoleId(null);
                refetchRoles();
            } else {
                console.error("Mutation Failed:", response?.data?.addJobrole?.message);
                message.error(response?.data?.addJobrole?.message || "Failed to process role");
            }
        } catch (error) {
            console.error("Error in addJobRoleHandleSubmit:", error);
            message.error(`Error: ${error.message || "Fill all the mandatory fields"}`);
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        const scrollableContainer = document.querySelector('.ant-layout');
        if (scrollableContainer) scrollableContainer.scrollTop = 0;
    }, []);

    const handleEdit = async (roleItem) => {
        setIsEditMode(true);
        setEditingRoleId(roleItem.id);
        setIsModalVisible(true);

        try {
            // Fetch Role Admin users for the specific jobroleId
            const { data: roleAdminSpecificData, error: roleAdminError } = await fetchRoleSpecificUsers({
                variables: {
                    roleName: "role admin",
                    jobroleId: parseInt(roleItem.id),
                },
            });

            // Fetch Clan Crew users for the specific jobroleId
            const { data: clanCrewSpecificData, error: clanCrewError } = await fetchRoleSpecificUsers({
                variables: {
                    roleName: "clan crew",
                    jobroleId: parseInt(roleItem.id),
                },
            });

            // Extract user IDs from the responses
            const roleAdminIds = roleAdminSpecificData?.getRoleSpecificUsersForRole?.map(user => user.id) || [];
            const clanCrewIds = clanCrewSpecificData?.getRoleSpecificUsersForRole?.map(user => user.id) || [];

            // Check for errors in the queries
            if (roleAdminError || clanCrewError) {
                console.error("Error fetching role-specific users:", roleAdminError || clanCrewError);
                message.error("Failed to load assigned users for this role.");
                // Fallback to empty arrays
                setFormData({
                    ...formData,
                    lense: roleItem.lenseNeeded || false,
                    darts: roleItem.dartsNeeded || false,
                    clan: roleItem.clanNeeded || false,
                    sync: roleItem.syncNeeded || false,
                    numberLogin: roleItem.numberLogin || false,
                    emailLogin: roleItem.emailLogin || false,
                    roleAdmin: [],
                    clanCrew: [],
                    jobroleAccessUserIds: [],
                    signInSignOutRequired: roleItem.signInSignOutRequired,
                    locationRequired: roleItem.locationRequired,
                    ldmsNeeded: roleItem.ldmsNeeded,
                    mirrorNeeded: roleItem.mirrorNeeded,
                    geoTracking: roleItem.geoTracking || false,
                });
                form.setFieldsValue({
                    "role name": roleItem.name,
                    "POC name": roleItem.pocName,
                    "contact no": roleItem.pocContactNumber,
                    "email": roleItem.pocEmail,
                    "loginMethod": roleItem.numberLogin ? "mobile" : roleItem.emailLogin ? "email" : "",
                    roleAdmin: [],
                    clanCrew: [],
                });
                return;
            }

            // Update formData with the fetched IDs
            const jobroleAccessUserIds = [...new Set([...roleAdminIds, ...clanCrewIds])];
            setFormData({
                ...formData,
                lense: roleItem.lenseNeeded || false,
                darts: roleItem.dartsNeeded || false,
                clan: roleItem.clanNeeded || false,
                sync: roleItem.syncNeeded || false,
                numberLogin: roleItem.numberLogin || false,
                emailLogin: roleItem.emailLogin || false,
                roleAdmin: roleAdminIds,
                clanCrew: clanCrewIds,
                jobroleAccessUserIds,
                signInSignOutRequired: roleItem.signInSignOutRequired,
                locationRequired: roleItem.locationRequired,
                ldmsNeeded: roleItem.ldmsNeeded,
                mirrorNeeded: roleItem.mirrorNeeded,
                geoTracking: roleItem.geoTracking || false
            });

            // Set form fields with the fetched data
            form.setFieldsValue({
                "role name": roleItem.name,
                "POC name": roleItem.pocName,
                "contact no": roleItem.pocContactNumber,
                "email": roleItem.pocEmail,
                "loginMethod": roleItem.numberLogin ? "mobile" : roleItem.emailLogin ? "email" : "",
                roleAdmin: roleAdminIds,
                clanCrew: clanCrewIds,
            });

        } catch (error) {
            console.error("Error setting role data:", error);
            message.error("Failed to load role data for editing.");
            // Fallback to empty arrays
            setFormData({
                ...formData,
                lense: roleItem.lenseNeeded || false,
                darts: roleItem.dartsNeeded || false,
                clan: roleItem.clanNeeded || false,
                sync: roleItem.syncNeeded || false,
                numberLogin: roleItem.numberLogin || false,
                emailLogin: roleItem.emailLogin || false,
                roleAdmin: [],
                clanCrew: [],
                jobroleAccessUserIds: [],
                signInSignOutRequired: roleItem.signInSignOutRequired,
                locationRequired: roleItem.locationRequired,
                ldmsNeeded: roleItem.ldmsNeeded || false,
                mirrorNeeded: roleItem.mirrorNeeded || false,
            });
            form.setFieldsValue({
                "role name": roleItem.name,
                "POC name": roleItem.pocName,
                "contact no": roleItem.pocContactNumber,
                "email": roleItem.pocEmail,
                "loginMethod": roleItem.numberLogin ? "mobile" : roleItem.emailLogin ? "email" : "",
                roleAdmin: [],
                clanCrew: [],
            });
        }
    };
    const handleCancel = () => {
        form.resetFields();
        setErrors({});
        setFormData((prevData) => ({
            ...prevData,
            lense: false,
            darts: false,
            clan: false,
            numberLogin: false,
            emailLogin: false,
            roleAdmin: [],
            clanCrew: [],
            jobroleAccessUserIds: [],
            signInSignOutRequired: false,
            locationRequired: false,
            ldmsNeeded: false,
            mirrorNeeded: false,
        }));
        setIsModalVisible(false);
        setIsEditMode(false);
        setEditingRoleId(null);
    };

    const handleDiscardClick = () => {
        navigate("/dashboard");
    };

    const handleToggle = () => {
        setIsToggled((prev) => !prev);
    };

    useEffect(() => {
        if (location.state?.selfRegistration !== undefined) {
            setIsToggled(location.state.selfRegistration);
        }
    }, [location.state?.selfRegistration]);

    const [uploadDocument] = useMutation(Upload_Document, {
        onCompleted: (data) => {
            if (data.uploadDocument.success) {
                const filename = data.uploadDocument?.data?.data?.filename;
                const imageUrl = data.uploadDocument?.data?.data?.url;
                setUploadedFilename(filename);
                setFormData((prevData) => ({
                    ...prevData,
                    imageUrl: imageUrl,
                }));
                message.success("Image uploaded successfully!");
            } else {
                message.error("Failed to upload image: " + data.uploadDocument.message);
            }
        },
        onError: (error) => {
            message.error("Upload failed: " + error.message);
        },
    });

    const navigate = useNavigate();

    const [addAccount, { error }] = useMutation(Account_Form_Query, {
        onCompleted: (data) => {
            message.success("Client created successfully!");
            navigate("/dashboard");
        },
        onError: (error) => {
            message.error("Something went wrong");
        },
    });

    const handleImageChange = ({ file }) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            setClientImage(e.target.result);
        };
        reader.readAsDataURL(file);
        if (!file) {
            message.error("Invalid file object.");
            return;
        }
        const allowedFormats = ["image/jpeg", "image/png"];
        const actualFile = file.originFileObj || file;
        if (!actualFile) {
            message.error("No valid file detected.");
            return;
        }
        if (!allowedFormats.includes(actualFile.type)) {
            message.error("Invalid file format. Only JPEG and PNG are allowed.");
            return;
        }
        try {
            const imageUrl = URL.createObjectURL(actualFile);
            setClientImage(imageUrl);
            setErrors((prevErrors) => ({
                ...prevErrors,
                clientImage: "",
            }));
            uploadDocument({
                variables: {
                    s3folder: "COMPANY_LOGO",
                    document: actualFile,
                },
                context: {
                    useMultipart: true,
                },
            });
        } catch (error) {
            console.error("Error handling the file:", error);
            message.error("File upload failed.");
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        setTouched((prevTouched) => ({
            ...prevTouched,
            [name]: true,
        }));
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        const updatedFormData = { ...formData, [name]: checked };
        setFormData(updatedFormData);
        setTouched((prevTouched) => ({
            ...prevTouched,
            projectAccess: true,
            [name]: true,
        }));
        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            if ((updatedFormData.darts || updatedFormData.clan) && !updatedFormData.numberLogin && !updatedFormData.emailLogin) {
                newErrors.loginMethod = "Please select a login method (Mobile or Email) when Darts or Clan is selected.";
            } else {
                delete newErrors.loginMethod;
            }
            if (!updatedFormData.lense && !updatedFormData.darts && !updatedFormData.clan && !updatedFormData.sync) {
                newErrors.projectAccess = "At least one project access option should be selected.";
            } else {
                delete newErrors.projectAccess;
            }
            return newErrors;
        });
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = "Enter client's name.";
        if (!urlRegex.test(formData.companyURL)) newErrors.companyURL = ' Enter a valid Client URL.';
        if (!formData.address) newErrors.address = "Enter office address 1.";
        if (!clientImage && !formData.mainLogoUrl) newErrors.clientImage = " * Upload image.";
        // if (!formData.address2) newErrors.address2 = "Enter office address 2.";
        if ((formData.darts || formData.clan) && !formData.numberLogin && !formData.emailLogin) newErrors.loginMethod = "Select mobile no or email-id.";
        if (!formData.lense && !formData.darts && !formData.clan && !formData.sync) newErrors.projectAccess = "At least one project access option should be selected.";
        if (!formData.roleName) newErrors.roleName = "Enter role name.";
        if (!formData.pocName) newErrors.pocName = "Enter POC name.";
        if (!formData.pocNumber) newErrors.pocNumber = "Enter contact number.";
        else if (formData.pocNumber.trim().length !== 10) newErrors.pocNumber = "Contact number must be exactly 10 digits.";
        if (!emailRegex.test(formData.pocEmail)) newErrors.pocEmail = ' Enter a email-id.';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const editvalidateForm = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = "Enter client's name.";
        if (!urlRegex.test(formData.companyURL)) newErrors.companyURL = 'Please enter a valid company URL.';
        if (!formData.address) newErrors.address = "Enter office address.";
        if (!clientImage && !formData.mainLogoUrl) newErrors.clientImage = "Upload image.";
        // if (!formData.address2) newErrors.address2 = "Enter office address 2.";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    useEffect(() => {
        setIsFormValid(validateForm());
    }, [formData]);

    const [updateClient, { loading: updateClientLoading }] = useMutation(update_Account, {
        onCompleted: (data) => {
            if (data.updateAccount.success) {
                message.success("Client updated successfully!");
                navigate("/dashboard");
            } else {
                message.error(data.updateAccount.message || "Failed to update client");
            }
        },
        onError: (error) => {
            message.error("Something went wrong: " + error.message);
        },
    });

    useEffect(() => {
        return () => {
            if (clientImage) {
                URL.revokeObjectURL(clientImage);
            }
        };
    }, [clientImage]);

    const handleSubmit = (e) => {
        e.preventDefault();
        const newTouched = {
            name: true,
            companyURL: true,
            address: true,
            address2: true,
            projectAccess: true,
            loginMethod: true,
            clientImage: true,
            roleName: true,
            pocName: true,
            pocNumber: true,
            pocEmail: true,
            assignedUsersForClient: true,
            jobroleAccessUserIds: true,
        };
        setTouched(newTouched);
        if (validateForm()) {
            const brandColor = formData.brandColor.startsWith("#")
                ? formData.brandColor.slice(1)
                : formData.brandColor;
            const jobroleAccessUserIds = [...new Set([...(formData.roleAdmin || []), ...(formData.clanCrew || [])])];
            const variables = {
                name: formData.name,
                url: formData.companyURL,
                address: formData.address,
                address2: formData.address2,
                brandColor: brandColor,
                roleName: formData.roleName,
                pocName: formData.pocName,
                pocNumber: formData.pocNumber,
                pocEmail: formData.pocEmail,
                lenseNeeded: formData.lense || false,
                dartsNeeded: formData.darts || false,
                clanNeeded: formData.clan || false,
                syncNeeded: formData.sync || false,
                loginMethod: formData.loginMethod,
                smallLogo: uploadedFilename,
                mainLogo: uploadedFilename,
                numberLogin: formData.numberLogin || false,
                emailLogin: formData.emailLogin || false,
                selfRegistration: isToggled,
                assignedUsersForClient: formData.assignedUsersForClient || [],
                jobroleAccessUserIds: jobroleAccessUserIds,
            };
            if (formData.numberLogin || formData.emailLogin) {
                variables.loginMethod = formData.numberLogin ? "mobile" : "email";
            }
            addAccount({
                variables,
                onCompleted: (response) => {
                    if (response.addAccount.success) {
                        setFormData({
                            name: "",
                            companyURL: "",
                            address: "",
                            address2: "",
                            brandColor: "",
                            roleName: "",
                            pocName: "",
                            pocEmail: "",
                            pocNumber: "",
                            contactNumber: "",
                            emailId: "",
                            lense: false,
                            darts: false,
                            clan: false,
                            loginMethod: "",
                            numberLogin: false,
                            emailLogin: false,
                            selfRegistration: false,
                            assignedAdmin: null,
                            assignedUsersForClient: [],
                            roleAdmin: [],
                            clanCrew: [],
                            jobroleAccessUserIds: [],
                        });
                        setTouched({});
                        setErrors({});
                        setClientImage(null);
                        message.success("Client added successfully!");
                        navigate("/dashboard");
                    } else {
                        message.error(response.addAccount.message || "Failed to add client.");
                    }
                },
                onError: (error) => {
                    const backendError = error?.message || "There was an error adding the client.";
                    message.error(backendError);
                },
            });
        } else {
            message.error("Fill all the mandatory fields");
        }
    };

    const handleLoginMethodChange = (e) => {
        const value = e.target.value;
        setFormData((prevFormData) => {
            const newFormData = { ...prevFormData };
            if (value === "mobile") {
                newFormData.numberLogin = true;
                newFormData.emailLogin = false;
            } else if (value === "email") {
                newFormData.numberLogin = false;
                newFormData.emailLogin = true;
            }
            return newFormData;
        });
        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            delete newErrors.loginMethod;
            return newErrors;
        });
    };

    useEffect(() => {
        setRole(rolesData?.getAllJobrole || []);
    }, [rolesData]);

    const existingRoles = rolesData?.getAllJobrole || [];
    const combinedRoles = [
        ...existingRoles,
        ...role.filter(newRole =>
            !existingRoles.some(existingRole =>
                existingRole?.name === newRole?.name
            )
        )
    ];

    const onFinish = (e) => {
        e.preventDefault();
        let brandColor = formData.brandColor || "FFAD01";
        brandColor = brandColor.startsWith("#") ? brandColor.slice(1) : brandColor;

        const newTouched = {
            name: true,
            companyURL: true,
            address: true,
            address2: true,
            clientImage: true,
            assignedUsersForClient: true,
        };
        setTouched(newTouched);

        if (editvalidateForm()) {
            const mainLogoPath = uploadedFilename ? uploadedFilename : null;
            const smallLogoPath = uploadedFilename ? uploadedFilename : null;

            // Ensure we're sending IDs, not names
            const assignedAdminIds = formData.assignedUsersForClient || [];

            const variables = {
                accountId: parseInt(accountId),
                name: formData.name,
                url: formData.companyURL,
                address: formData.address,
                address2: formData.address2,
                brandColor: brandColor,
                mainLogo: mainLogoPath,
                smallLogo: smallLogoPath,
                syncNeeded: formData.sync || false,
                emailLogin: false,
                numberLogin: false,
                selfRegistration: isToggled,
                assignedUsersForClient: assignedAdminIds, // Sending IDs
            };

            updateClient({
                variables: variables,
            })
                .then(() => {
                    setTouched({});
                    setErrors({});
                    setClientImage(null);
                    navigate("/dashboard");
                })
                .catch((error) => {
                    console.error("Error updating client:", error);
                    message.error("There was an error updating the client.");
                });
        } else {
            message.error("Fill all the mandatory fields");
        }
    };

    useEffect(() => {
        return () => {
            if (clientImage) {
                URL.revokeObjectURL(clientImage);
            }
        };
    }, [clientImage]);

    const [deleteAccount, { loading: deleteAccountLoading, error: deleteAccountError }] = useMutation(Delete_Account, {
        variables: { accountId },
        onCompleted: (response) => {
            if (response.deleteAccount.success) {
                message.success("Account deleted successfully!");
                setShowDeleteAccountModal(false);
                navigate("/dashboard");
            } else {
                message.error(response.deleteAccount.message);
            }
        },
        onError: (err) => {
            message.error("Failed to delete account: " + err.message);
        },
    });

    const handleDelete = () => {
        deleteAccount();
    };

    const [deleteJobRole, { loading: deleteJobRoleLoading, error: deleteJobRoleError, refetch: refetchDeleteRoles }] = useMutation(Delete_Job_Role, {
        variables: { jobroleId: selectedRoleId },
        onCompleted: async (response) => {
            if (response.deleteJobrole.success) {
                message.success("Role deleted successfully!");
                setShowDeleteJobRoleModal(false);
                await refetchRoles();
            } else {
                message.error(response.deleteJobrole.message);
            }
        },
        onError: (err) => {
            message.error("Failed to delete role: " + err.message);
        },
    });

    const handleJobRoleDelete = () => {
        deleteJobRole();
    };

    const handleDeleteClick = (roleId) => {
        setSelectedRoleId(roleId);

        const rolesCount = Array.isArray(role) ? role.length : 0;

        if (rolesCount === 1) {
            setDeleteType("single");
        } else {
            setDeleteType("multiple");
        }

        setShowDeleteJobRoleModal(true);
    };

    const handleAssignedAdminChange = (value, option) => {
        setFormData((prev) => ({
            ...prev,
            assignedUsersForClient: value, // value is already an array since mode="multiple"
        }));
    };

    const handleRoleAdminChange = (value) => {
        setFormData(prev => {
            const newJobroleAccessUserIds = [...new Set([...(prev.clanCrew || []), ...value])];
            return { ...prev, roleAdmin: value, jobroleAccessUserIds: newJobroleAccessUserIds };
        });
    };

    const handleClanCrewChange = (value) => {
        setFormData(prev => {
            const newJobroleAccessUserIds = [...new Set([...(prev.roleAdmin || []), ...value])];
            return { ...prev, clanCrew: value, jobroleAccessUserIds: newJobroleAccessUserIds };
        });
    };

    return (
        <Content style={{ margin: "16px", marginTop: "0px" }}>
            <div className="create-client-container">
                <style>{customStyles}</style>
                <div className="createClientHeading">
                    {accountId ? "Edit Client" : "Create Client"}
                </div>
                <Form.Item name="clientImage">
                    <div className="upload-container relative">
                        {/* <span className="absolute -top-2 left-20 text-[#AD0101] text-sm">*Uplodeimage</span> */}
                        <Upload
                            name="clientImage"
                            showUploadList={false}
                            customRequest={handleImageChange}
                            accept=".jpg,.jpeg,.png"
                            openFileDialogOnClick={!isPickingColor}
                            beforeUpload={(file) => {
                                if (isPickingColor) {
                                    return false;
                                }
                                return true;
                            }}
                        >
                            <div className={`image-upload-circle ${isPickingColor ? 'picker-active' : ''}`}
                                onClick={(e) => isPickingColor && e.stopPropagation()}>
                                {clientImage ? (
                                    <img
                                        ref={imageRef}
                                        src={clientImage}
                                        alt="Uploaded"
                                        className={`uploaded-image-create-client-form ${isPickingColor ? 'color-picking-cursor' : ''}`}
                                        onClick={handleImageClick}
                                        onMouseMove={handleMouseMove}
                                        onLoad={initializeCanvas}
                                    />
                                ) : formData.imageUrl ? (
                                    <img
                                        ref={imageRef}
                                        src={formData.imageUrl}
                                        alt="Existing Client"
                                        className={`uploaded-image-create-client-form ${isPickingColor ? 'color-picking-cursor' : ''}`}
                                        onClick={handleImageClick}
                                        onLoad={initializeCanvas}
                                    />
                                ) : formData.mainLogoUrl ? (
                                    <img
                                        ref={imageRef}
                                        src={formData.mainLogoUrl}
                                        alt="Existing Logo"
                                        className={`uploaded-image-create-client-form ${isPickingColor ? 'color-picking-cursor' : ''}`}
                                        onClick={handleImageClick}
                                        onLoad={initializeCanvas}
                                    />
                                ) : (
                                    <img
                                        src={CreateClientImage}
                                        alt="Upload Icon"
                                        className="upload-icon"
                                    />
                                )}
                                {isPickingColor && selectedColor && (
                                    <>
                                        <div
                                            style={{
                                                left: `${position.x + 20}px`,
                                                top: `${position.y + 20}px`,
                                            }}
                                        >
                                        </div>
                                    </>
                                )}
                            </div>
                        </Upload>
                        {touched.clientImage && errors.clientImage && (
                            <div className="createClientErrors">{errors.clientImage}</div>
                        )}
                        {(clientImage || formData.imageUrl || formData.mainLogoUrl) && (
                            <button
                                style={{
                                    background: "none",
                                    width: "9%",
                                    height: "0%",
                                    border: "none",
                                    marginTop: "1%"
                                }}
                                type="button"
                                onClick={startColorPicking}
                                className={`${isPickingColor ? '' : 'text-gray-500'}`}
                                title={isPickingColor ? "Color picker active" : "Pick color from image"}
                            >
                                <Pencil style={{ width: "30%" }} />
                                {isPickingColor && selectedColor && (
                                    <div>{selectedColor.hex.toUpperCase()}</div>
                                )}
                                {isPickingColor && selectedColor && (
                                    <div
                                        className="color-preview"
                                        style={{
                                            backgroundColor: selectedColor.rgb,
                                            border: '1px solid #ddd',
                                            width: '40px',
                                            height: '40px',
                                            marginTop: '10px',
                                            borderRadius: "80px",
                                            marginLeft: "25%"
                                        }}
                                    />
                                )}
                            </button>
                        )}
                    </div>
                </Form.Item>
                <Row className="row-container client-profile-row">
                    <Col className="client-profile-heading" sm={12} xs={12} md={20} lg={20} style={{ marginBottom: "1%" }}>
                        <div className="clientNameHeading">Client's Profile</div>
                    </Col>
                    <Col sm={12} xs={23} md={10} lg={11} style={{ marginBottom: "2%", marginRight: "3.6%" }}>
                        <p style={{ fontSize: "15px", color: "#1C1B1F", marginBottom: "1%" }}>Client's Name<span style={{ color: "#AD0101", marginLeft: "4px" }}>*</span></p>
                        <TextInputField
                            name="name"
                            value={formData.name}
                            placeholder="Enter client's name"
                            feedbackMessage="Please input the client name."
                            validationRegex={/^[a-zA-Z0-9\s.,!?@#$%^&*()\-_=+\[\]{}|;:'"<>/~`]*$/}
                            onChange={(e) => {
                                const value = e.target.value.trimStart();

                                handleInputChange({
                                    ...e,
                                    target: {
                                        ...e.target,
                                        name: "name",
                                        value: value,
                                    },
                                });
                            }}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" && !e.shiftKey) {
                                    e.preventDefault();
                                    handleSubmit(e);
                                }
                            }}
                        />
                        {touched.name && errors.name && (
                            <div className="createClientErrors">{errors.name}</div>
                        )}
                    </Col>
                    <Col
                        sm={12}
                        xs={23}
                        md={10}
                        lg={11}
                        style={{ marginBottom: "2%", marginRight: "0.5%" }}
                    >
                        <p
                            style={{
                                fontSize: "15px",
                                color: "#1C1B1F",
                                marginBottom: "1%",
                            }}
                        >
                            Website URL
                            <span style={{ color: "#AD0101", marginLeft: "4px" }}>*</span>
                        </p>

                        <TextInputField
                            name="companyURL"
                            value={formData.companyURL}
                            placeholder="Enter website URL"
                            feedbackMessage="Please input the company URL."
                            onChange={(e) =>
                                handleInputChange({
                                    target: {
                                        name: e.target.name,
                                        value: e.target.value.trimStart(),
                                    },
                                })
                            }
                            onKeyDown={(e) => {
                                if (e.key === "Enter" && !e.shiftKey) {
                                    e.preventDefault();
                                    handleSubmit(e);
                                }
                            }}
                        />

                        {touched.companyURL && errors.companyURL && (
                            <div className="createClientErrors">{errors.companyURL}</div>
                        )}
                    </Col>
                    <Col sm={12} xs={23} md={10} lg={11} style={{ marginBottom: "2%", marginRight: "3.6%" }}>
                        <p style={{ fontSize: "15px", color: "#1C1B1F", marginBottom: "1%" }}>Office Address 1<span style={{ color: "#AD0101", marginLeft: "4px" }}>*</span></p>
                        <TextInputField
                            name="address"
                            value={formData.address}
                            placeholder="Enter office address 1"
                            feedbackMessage="Please input the address 1."
                            validationRegex={validationRegexAddress}
                            onChange={handleInputChange}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' && !e.shiftKey) {
                                    e.preventDefault();
                                    handleSubmit(e);
                                }
                            }}
                        />
                        {touched.address && errors.address && (
                            <div className="createClientErrors">{errors.address}</div>
                        )}
                    </Col>
                    <Col sm={12} xs={23} md={10} lg={11} style={{ marginBottom: "2%", marginRight: "0.5%" }}>
                        <p style={{ fontSize: "15px", color: "#1C1B1F", marginBottom: "1%" }}>Office Address 2</p>
                        <TextInputField
                            name="address2"
                            value={formData.address2}
                            placeholder="Enter office address 2"
                            feedbackMessage="Please input the address 2."
                            validationRegex={validationRegexAddress}
                            onChange={handleInputChange}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' && !e.shiftKey) {
                                    e.preventDefault();
                                    handleSubmit(e);
                                }
                            }}
                        />
                        {/* {touched.address2 && errors.address2 && (
                            <div className="createClientErrors">{errors.address2}</div>
                        )} */}
                    </Col>
                    <Col sm={12} xs={23} md={10} lg={11} style={{ marginBottom: "2%", marginRight: "3.6%" }}>
                        <p style={{ fontSize: "15px", color: "#1C1B1F", marginBottom: "1%" }}>
                            Assigned Admin
                        </p>

                        <Select
                            name="assignedAdmin"
                            mode="multiple"
                            value={formData.assignedUsersForClient || []}
                            placeholder="Select assigned admin"
                            onChange={handleAssignedAdminChange}
                            // style={{ width: "106%" }}
                            className="create-client-dropdown"
                            loading={assignedAdminLoading}
                            disabled={assignedAdminLoading || assignedAdminError}
                            showSearch
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                                (option?.label ?? "").toString().toLowerCase().includes(input.toLowerCase())
                            }
                            notFoundContent="No data found"
                            tagRender={(props) => {
                                const { label, closable, onClose } = props;
                                return (
                                    <div
                                        style={{
                                            background: "#c40000",
                                            color: "#fff",
                                            borderRadius: "6px",
                                            height: "18px",
                                            marginLeft: "8px",
                                            padding: "0px 8px",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            marginRight: "6px",
                                            fontSize: "11px",
                                            lineHeight: "13px",
                                            cursor: "pointer",
                                            userSelect: "none",
                                        }}
                                    >
                                        <span style={{ color: "#fff", marginRight: "6px" }}>{label}</span>
                                        {closable && (
                                            <span
                                                onClick={onClose}
                                                style={{
                                                    color: "#fff",
                                                    cursor: "pointer",
                                                    fontSize: "12px",
                                                    fontWeight: "bold",
                                                    display: "flex",
                                                    alignItems: "center",
                                                }}
                                            >
                                                ×
                                            </span>
                                        )}
                                    </div>
                                );
                            }}
                        >
                            {assignedAdminOptions.map((option) => (
                                <Select.Option key={option.value} value={option.value} label={option.label}>
                                    {option.label}
                                </Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col sm={12} xs={22} md={11} lg={11} className="brandColorInput">
                        <p className="brand-color-label" style={{ fontSize: "15px", color: "#1C1B1F", marginBottom: "1%" }}>Brand Color</p>
                        <div className="brand-color-container">
                            <TextInputField
                                type="text"
                                value={normalizeColor(formData.brandColor)}
                                placeholder="Brand Color"
                                onClick={handleColorClick}
                                className="brandcolorinputfield"
                            />
                            <span
                                className="color-display-circle"
                                style={{
                                    backgroundColor: normalizeColor(formData.brandColor)
                                }}
                                onClick={handleColorClick}
                            ></span>
                            {showPicker && (
                                <div className="color-picker-container">
                                    <SketchPicker
                                        className="custom-sketch-picker"
                                        color={normalizeColor(formData.brandColor)}
                                        onChange={handleColorChange}
                                        presentColors={[]}
                                    />
                                    <button
                                        onClick={() => setShowPicker(false)}
                                        className="close-picker-button"
                                    >
                                        Close
                                    </button>
                                </div>
                            )}
                            {showPicker && (
                                <div
                                    onClick={() => setShowPicker(false)}
                                    className="overlay"
                                ></div>
                            )}
                        </div>
                    </Col>
                </Row>
                {!accountId && (
                    <div className="row-container role-creation-container">
                        <Row>
                            <Col sm={12} xs={12} md={12} lg={6} style={{ marginBottom: "1%", marginRight: "-5%" }}>
                                <div className="clientNameHeading">Role</div>
                            </Col>
                        </Row>
                        <Row className="client-role-fields-row">
                            <Col>
                                <p style={{ fontSize: "15px", color: "#1C1B1F", marginBottom: "1%" }}>Role Name<span style={{ color: "#AD0101", marginLeft: "4px" }}>*</span></p>
                                <TextInputField
                                    name="roleName"
                                    value={formData.roleName}
                                    placeholder="Enter role name"
                                    feedbackMessage="Please input the role name."
                                    validationRegex={validationRegexOnlyAlpha}
                                    onChange={handleInputChange}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' && !e.shiftKey) {
                                            e.preventDefault();
                                            handleSubmit(e);
                                        }
                                    }}
                                />
                                {touched.roleName && errors.roleName && (
                                    <div className="createClientErrors">{errors.roleName}</div>
                                )}
                            </Col>
                            <Col>
                                <p style={{ fontSize: "15px", color: "#1C1B1F", marginBottom: "1%" }}>POC Name<span style={{ color: "#AD0101", marginLeft: "4px" }}>*</span></p>
                                <TextInputField
                                    name="pocName"
                                    value={formData.pocName}
                                    placeholder="Enter POC name"
                                    feedbackMessage="Please input the POC name."
                                    validationRegex={validationRegexOnlyAlpha}
                                    onChange={handleInputChange}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' && !e.shiftKey) {
                                            e.preventDefault();
                                            handleSubmit(e);
                                        }
                                    }}
                                />
                                {touched.pocName && errors.pocName && (
                                    <div className="createClientErrors">{errors.pocName}</div>
                                )}
                            </Col>
                            <Col>
                                <p style={{ fontSize: "15px", color: "#1C1B1F", marginBottom: "1%" }}>Contact Number<span style={{ color: "#AD0101", marginLeft: "4px" }}>*</span></p>
                                <TextInputField
                                    name="pocNumber"
                                    value={formData.pocNumber}
                                    placeholder="Enter contact number"
                                    feedbackMessage="Please input the contact number."
                                    validationRegex={validationRegexMobileNo}
                                    onChange={handleInputChange}
                                    maxLength={10}
                                />
                                {touched.pocNumber && errors.pocNumber && (
                                    <div className="createClientErrors">{errors.pocNumber}</div>
                                )}
                            </Col>
                            <Col>
                                <p style={{ fontSize: "15px", color: "#1C1B1F", marginBottom: "1%" }}>Email ID<span style={{ color: "#AD0101", marginLeft: "4px" }}>*</span></p>
                                <TextInputField
                                    name="pocEmail"
                                    value={formData.pocEmail}
                                    placeholder="Enter email id"
                                    feedbackMessage="Please input the email Id."
                                    onChange={handleInputChange}
                                />
                                {touched.pocEmail && errors.pocEmail && (
                                    <div className="createClientErrors">{errors.pocEmail}</div>
                                )}
                            </Col>
                            <Col>
                                <p style={{ fontSize: "15px", color: "#1C1B1F", marginBottom: "1%" }}>Role Admin</p>
                                <Select
                                    name="roleAdmin"
                                    mode="multiple"
                                    value={formData.roleAdmin}
                                    placeholder="Select role admin"
                                    onChange={handleRoleAdminChange}
                                    // style={{ width: "106%" }}
                                    className="create-client-dropdown"
                                    loading={roleAdminLoading}
                                    disabled={roleAdminLoading || roleAdminError}
                                >
                                    {roleAdminOptions.map(option => (
                                        <Select.Option key={option.value} value={option.value}>
                                            {option.label}
                                        </Select.Option>
                                    ))}
                                </Select>
                                {touched.roleAdmin && errors.roleAdmin && (
                                    <div className="createClientErrors">{errors.roleAdmin}</div>
                                )}
                            </Col>
                            <Col>
                                <p style={{ fontSize: "15px", color: "#1C1B1F", marginBottom: "1%" }}>Clan Crew</p>
                                <Select

                                    name="clanCrew"
                                    value={formData.clanCrew}
                                    mode="multiple"
                                    placeholder="Select clan crew"
                                    onChange={handleClanCrewChange}
                                    // style={{ width: "107%" }}
                                    className="create-client-dropdown"
                                    loading={clanCrewLoading}
                                    disabled={clanCrewLoading || clanCrewError}

                                    tagRender={(props) => {
                                        const { label, closable, onClose } = props;

                                        return (
                                            <div
                                                style={{
                                                    background: "#c40000",
                                                    color: "#fff",
                                                    borderRadius: "6px",
                                                    height: "18px",
                                                    marginLeft: "8px",
                                                    padding: "0px 8px",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    marginRight: "6px",
                                                    fontSize: "11px",
                                                    // fontWeight: "500",
                                                    lineHeight: "24px",
                                                    cursor: "pointer",
                                                    userSelect: "none",
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        color: "#fff",
                                                        marginRight: "6px",
                                                    }}
                                                >
                                                    {label}
                                                </span>

                                                {closable && (
                                                    <span
                                                        onClick={onClose}
                                                        style={{
                                                            color: "#fff",
                                                            cursor: "pointer",
                                                            fontSize: "12px",
                                                            fontWeight: "bold",
                                                            display: "flex",
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        ×
                                                    </span>
                                                )}
                                            </div>
                                        );
                                    }}
                                >
                                    {clanCrewOptions.map((option) => (
                                        <Select.Option key={option.value} value={option.value}>
                                            {option.label}
                                        </Select.Option>
                                    ))}
                                </Select>
                                {touched.clanCrew && errors.clanCrew && (
                                    <div className="createClientErrors">{errors.clanCrew}</div>
                                )}
                            </Col>
                            {/* <Col sm={12} xs={23} md={10} lg={11} style={{ marginBottom: "2%", marginRight: "3.6%" }}>
                                <p style={{ fontSize: "15px", color: "#1C1B1F", marginBottom: "1%" }}> Assigned Role</p>
                                <Select
                                    name="roleAdmin"
                                    mode="multiple"
                                    value={formData.roleAdmin}
                                    placeholder="Select assigned roles"
                                    onChange={handleRoleAdminChange}
                                    style={{ width: "105%" }}
                                    loading={roleAdminLoading}
                                    disabled={roleAdminLoading || roleAdminError}
                                >
                                    {roleAdminOptions.map(option => (
                                        <Select.Option key={option.value} value={option.value}>
                                            {option.label}
                                        </Select.Option>
                                    ))}
                                </Select>
                                {touched.roleAdmin && errors.roleAdmin && (
                                    <div className="createClientErrors">{errors.roleAdmin}</div>
                                )}
                            </Col> */}
                        </Row>

                        <Row>
                            <Col sm={12} xs={12} md={12} lg={6} style={{ marginBottom: "1%", marginRight: "-5%" ,top: "14px"}}>
                                <div className="productAccessHeading">Product Access<span style={{ color: "#AD0101", marginLeft: "4px" }}>*</span></div>
                            </Col>
                        </Row>
                        <Row style={{ position: "relative", top: "2px" }}>
                            <Col sm={12} xs={10} md={6} lg={6} style={{ marginRight: "-3%", }}>
                                <Form.Item>
                                    <Checkbox
                                        checked={false}
                                        disabled={true}
                                    >
                                        LENSE
                                    </Checkbox>
                                </Form.Item>
                            </Col>
                            <Col sm={12} xs={10} md={6} lg={6} style={{ marginLeft: "-13%" }}>
                                <Form.Item>
                                    <Checkbox
                                        checked={formData.darts}
                                        name="darts"
                                        onChange={handleCheckboxChange}
                                        style={{ color: formData.emailLogin ? 'black' : '' }}
                                    >
                                        DARTS
                                    </Checkbox>
                                </Form.Item>
                            </Col>
                            <Col sm={12} xs={10} md={6} lg={6} style={{ marginLeft: "-15%" }}>
                                <Form.Item>
                                    <Checkbox
                                        checked={formData.clan}
                                        onChange={handleCheckboxChange}
                                        // className="custom-checkbox"
                                        name="clan"
                                    >
                                        CLAN
                                    </Checkbox>
                                </Form.Item>
                            </Col>
                            <Col sm={12} xs={10} md={6} lg={6} style={{ marginLeft: "-16%" }}>
                                <Form.Item>
                                    <Checkbox
                                        checked={formData.sync}
                                        onChange={handleCheckboxChange}
                                        // disabled
                                        name="sync"
                                    >
                                        SYNC
                                    </Checkbox>
                                </Form.Item>
                            </Col>
                        </Row>
                        {touched.projectAccess && errors.projectAccess && (
                            <div className="createClientErrors">{errors.projectAccess}</div>
                        )}
                        {(formData.darts || formData.clan) && (
                            <Row
                                className="role-login-through-row"
                                style={{ position: "relative", top: "-7px" }}
                            >
                                <label style={{ fontSize: "15px", color: "#1C1B1F", marginRight: "10px", marginTop: "0.4%" }}>
                                    Login Through:
                                </label>
                                <Form.Item style={{ marginBottom: 0 }}>
                                    <Radio.Group
                                        onChange={handleLoginMethodChange}
                                        value={formData.numberLogin ? "mobile" : formData.emailLogin ? "email" : ""}
                                    >
                                        <Radio value="mobile" className="custom-radio">Mobile no.</Radio>
                                        <Radio value="email" className="custom-radio">Email-ID</Radio>
                                    </Radio.Group>
                                </Form.Item>
                            </Row>
                        )}
                        {touched.loginMethod && errors.loginMethod && (
                            <div className="createClientErrors">{errors.loginMethod}</div>
                        )}
                    </div>
                )}
                {accountId && (
                    <div className="row-container">
                        <div className="clientNameHeading">Role Management</div>

                        <div className="role-cards-container">
                            {combinedRoles.map((roleItem, index) => (
                                roleItem?.name && (
                                    <div key={`role-${index}`} className="role-card">
                                        <div className="role-header">
                                            <div className="role-card-content">
                                                <span
                                                    style={{ display: "flex", justifyContent: "space-between" }}
                                                    onClick={() => handleDeleteClick(roleItem.id)}
                                                >
                                                    <div className="role-label">Role</div>
                                                    <img className="rolemanagementdeletebutton" src={DeleteButton} alt="Delete" />
                                                </span>
                                                <div className="role-title-container">
                                                    <div className="role-title">{roleItem.name}</div>
                                                    <div className="role-title-tooltip">{roleItem.name}</div>
                                                </div>
                                                <button
                                                    className="rolemanagementeditandimage"
                                                    onClick={() => handleEdit(roleItem)}
                                                >
                                                    Edit
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )
                            ))}
                            <img
                                src={AddRoleIcon}
                                alt="Uploaded"
                                className="AddRoleImage"
                                onClick={showModal}
                            />
                        </div>

                        {showdeleteJobRoleModal && selectedRoleId && (
                            <Modal
                                open={showdeleteJobRoleModal}
                                onCancel={() => {
                                    setShowDeleteJobRoleModal(false);
                                    setSelectedRoleId(null);
                                    setDeleteType(null);
                                }}
                                footer={null}
                                centered
                                width={500}
                                closable={false}
                            >
                                {deleteType === "single" ? (
                                    <p>
                                        Deleting this role will also remove the client
                                        <span style={{ fontWeight: "bold" }}>‘{formData.name}’</span>
                                        and all associated data from the system. This data will be archived for 1 year. Do you wish to continue?
                                    </p>
                                ) : (
                                    <p>
                                        Do you want to delete this
                                        <span style={{ fontWeight: "bold" }}> Role?</span>
                                    </p>
                                )}


                                <div className="delete-modal-footer">
                                    {deleteType === "single" ? (
                                        <>
                                            <button
                                                className="delete-account"
                                                onClick={() => {
                                                    // delete the entire account when removing the only role
                                                    handleDelete();
                                                }}
                                                disabled={deleteAccountLoading}
                                            >
                                                {deleteAccountLoading ? <span className="inline-block w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span> : 'Delete'}
                                            </button>
                                            <button
                                                className="delete-cancel"
                                                onClick={() => {
                                                    setShowDeleteJobRoleModal(false);
                                                    setSelectedRoleId(null);
                                                    setDeleteType(null);
                                                }}
                                            >
                                                Cancel
                                            </button>
                                        </>
                                    ) : (
                                        <>
                                            <button
                                                className="delete-account"
                                                onClick={handleJobRoleDelete}
                                            >
                                                {deleteJobRoleLoading ? <span className="inline-block w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span> : 'Delete'}
                                            </button>
                                            <button
                                                className="delete-cancel"
                                                onClick={() => {
                                                    setShowDeleteJobRoleModal(false);
                                                    setSelectedRoleId(null);
                                                    setDeleteType(null);
                                                }}
                                            >
                                                Cancel
                                            </button>
                                        </>
                                    )}
                                </div>
                            </Modal>
                        )}
                        <Modal
                            width={500}
                            closable={false}
                            visible={isModalVisible}
                            onCancel={handleCancel}
                            footer={[
                                <div key="footer" className="role-management-modal-footer">
                                    <button key="cancel" onClick={handleCancel} className="cancel-button">
                                        Cancel
                                    </button>
                                    <button key="create" onClick={addJobRoleHandleSubmit} className="create-button">
                                        {isEditMode ? (addRoleLoading ? <span className="inline-block w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span> : "Update") : (addRoleLoading ? <span className="inline-block w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span> : "Create")}
                                    </button>
                                </div>
                            ]}
                        >
                            <Form form={form} layout="vertical" requiredMark={false}>
                                <div style={{ display: "flex", flexWrap: "wrap", gap: "12px 16px" }}>

                                    {/* Role Name - smaller */}
                                    <div style={{ width: "calc(50% - 8px)" }}>
                                        <Form.Item
                                            label={
                                                <span style={{ fontSize: "13px", fontWeight: "500" }}>
                                                    Role Name
                                                    <span style={{ color: "#AD0101", marginLeft: "4px" }}>
                                                        *
                                                    </span>
                                                </span>
                                            }
                                            name="role name"
                                            getValueFromEvent={(e) => e.target.value.trimStart()}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Enter a role name",
                                                },
                                                {
                                                    pattern: validationRegexOnlyAlphaAddRole,
                                                    message: "Enter valid role name",
                                                },
                                            ]}
                                            style={{ marginBottom: "8px" }}
                                        >
                                            <Input
                                                placeholder="Enter Role Name"
                                                style={{
                                                    height: "34px",
                                                    fontSize: "13px",
                                                    borderRadius: "6px",
                                                }}
                                            />
                                        </Form.Item>
                                    </div>

                                    {/* POC Name - smaller */}
                                    <div style={{ width: "calc(50% - 8px)" }}>
                                        <Form.Item
                                            label={
                                                <span style={{ fontSize: "13px", fontWeight: "500" }}>
                                                    POC Name
                                                    <span style={{ color: "#AD0101", marginLeft: "4px" }}>
                                                        *
                                                    </span>
                                                </span>
                                            }
                                            name="POC name"
                                            getValueFromEvent={(e) => e.target.value.trimStart()}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Enter a POC Name",
                                                },
                                                {
                                                    pattern: validationRegexOnlyAlphaAddRole,
                                                    message: "Enter valid POC name",
                                                },
                                            ]}
                                            style={{ marginBottom: "8px" }}
                                        >
                                            <Input
                                                placeholder="Enter POC Name"
                                                style={{
                                                    height: "34px",
                                                    fontSize: "13px",
                                                    borderRadius: "6px",
                                                }}
                                            />
                                        </Form.Item>
                                    </div>

                                    {/* Contact No - smaller */}
                                    <div style={{ width: "calc(50% - 8px)" }}>
                                        <Form.Item
                                            label={
                                                <span style={{ fontSize: "13px", fontWeight: "500" }}>
                                                    Contact No
                                                    <span style={{ color: "#AD0101", marginLeft: "4px" }}>*</span>
                                                </span>
                                            }
                                            name="contact no"
                                            validateTrigger="onBlur"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Enter a Contact Number",
                                                },
                                                {
                                                    pattern: /^[6-9]\d{9}$/,
                                                    message: "Enter a valid 10-digit mobile number!",
                                                },
                                            ]}
                                            style={{ marginBottom: "8px" }}
                                        >
                                            <Input
                                                placeholder="Enter Contact No.."
                                                style={{
                                                    height: "34px",
                                                    fontSize: "13px",
                                                    borderRadius: "6px",
                                                }}
                                                maxLength={10}
                                                onKeyDown={(e) => {
                                                    const value = e.currentTarget.value;

                                                    // Allow control keys
                                                    if (
                                                        ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(e.key)
                                                    ) {
                                                        return;
                                                    }

                                                    // Only allow numbers
                                                    if (!/^\d$/.test(e.key)) {
                                                        e.preventDefault();
                                                        return;
                                                    }

                                                    // First digit must be 6, 7, 8, or 9
                                                    if (value.length === 0 && !/[6-9]/.test(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    let value = e.target.value.replace(/\D/g, "").slice(0, 10);

                                                    // If first digit is not 6-9, remove it
                                                    if (value.length > 0 && !/^[6-9]/.test(value)) {
                                                        value = "";
                                                    }

                                                    e.target.value = value;
                                                }}
                                                onPaste={(e) => {
                                                    const pasted = e.clipboardData.getData("Text").replace(/\D/g, "");

                                                    // Paste must start with 6-9
                                                    if (pasted && !/^[6-9]/.test(pasted)) {
                                                        e.preventDefault();
                                                        return;
                                                    }

                                                    e.preventDefault();

                                                    const value = pasted.slice(0, 10);

                                                    // Set value through AntD Form
                                                    e.currentTarget.value = value;
                                                    e.currentTarget.dispatchEvent(
                                                        new Event("input", { bubbles: true })
                                                    );
                                                }}
                                            />
                                        </Form.Item>
                                    </div>

                                    {/* Email-ID - smaller */}
                                    <div style={{ width: "calc(50% - 8px)" }}>
                                        <Form.Item
                                            label={
                                                <span style={{ fontSize: "13px", fontWeight: "500" }}>
                                                    Email-ID
                                                    <span style={{ color: "#AD0101", marginLeft: "4px" }}>
                                                        *
                                                    </span>
                                                </span>
                                            }
                                            name="email"
                                            getValueFromEvent={(e) => e.target.value.trimStart()}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Enter a Email-ID",
                                                },
                                                {
                                                    pattern: emailRegexAddRole,
                                                    message: "Enter valid Email-ID",
                                                },
                                            ]}
                                            style={{ marginBottom: "8px" }}
                                        >
                                            <Input
                                                placeholder="Enter Email-ID"
                                                style={{
                                                    height: "34px",
                                                    fontSize: "13px",
                                                    borderRadius: "6px",
                                                }}
                                            />
                                        </Form.Item>
                                    </div>

                                    {/* Role Admin - bigger, side by side */}
                                    <div style={{ width: "calc(50% - 8px)" }}>
                                        <Form.Item
                                            label={<span style={{ fontSize: "14px", fontWeight: "600" }}>Role Admin</span>}
                                            name="roleAdmin"
                                            style={{ marginBottom: "8px" }}
                                        >
                                            <Select
                                                mode="multiple"
                                                // showSearch
                                                placeholder="Select Role Admin"
                                                onChange={handleRoleAdminChange}
                                                loading={roleAdminLoading}
                                                disabled={roleAdminLoading || roleAdminError}
                                                value={formData.roleAdmin}
                                                optionFilterProp="children"
                                                style={{ width: "105%" }}
                                                dropdownStyle={{ minWidth: "200px" }}
                                                size="large"
                                            >
                                                {roleAdminOptions.map(option => (
                                                    <Select.Option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </div>

                                    {/* Clan Crew - bigger, side by side */}
                                    <div style={{ width: "calc(50% - 8px)" }}>
                                        <Form.Item
                                            label={<span style={{ fontSize: "14px", fontWeight: "600" }}>Clan Crew</span>}
                                            name="clanCrew"
                                            style={{ marginBottom: "8px" }}
                                        >
                                            <Select
                                                mode="multiple"
                                                showSearch
                                                placeholder="Select Clan Crew"
                                                onChange={handleClanCrewChange}
                                                loading={clanCrewLoading}
                                                disabled={clanCrewLoading || clanCrewError}
                                                value={formData.clanCrew}
                                                optionFilterProp="children"
                                                // style={{ width: "106%" }}
                                                className="create-client-dropdown"
                                                dropdownStyle={{ minWidth: "200px" }}
                                                size="large"
                                            >
                                                {clanCrewOptions.map(option => (
                                                    <Select.Option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </div>

                                </div>

                                {/* Product Access */}
                                <div style={{ fontSize: "15px", fontWeight: "bold", marginTop: "12px", marginBottom: "8px" }}>
                                    Product Access<span style={{ color: "#AD0101", marginLeft: "4px" }}>*</span>
                                </div>
                                <Form.Item
                                    name="productAccess"
                                    style={{ marginBottom: "8px" }}
                                    rules={[{
                                        validator: () => {
                                            if (!formData.lense && !formData.darts && !formData.clan && !formData.sync) {
                                                return Promise.reject('Please select at least one product access');
                                            }
                                            return Promise.resolve();
                                        }
                                    }]}
                                >
                                    <div style={{ display: "flex", gap: "24px" }}>
                                        <label className="flex items-center gap-2 text-[13px] cursor-pointer">
                                            <input
                                                type="checkbox"
                                                checked={formData.lense}
                                                onChange={() => roleManagementHandleCheckboxChange('lense')}
                                                className="custom-checkbox"
                                            />
                                            LENSE
                                        </label>
                                        <label className="flex items-center gap-2 text-[13px] cursor-pointer">
                                            <input
                                                type="checkbox"
                                                checked={formData.darts}
                                                onChange={() => roleManagementHandleCheckboxChange('darts')}
                                                className="custom-checkbox"
                                            />
                                            DARTS
                                        </label>
                                        <label className="flex items-center gap-2 text-[13px] cursor-pointer">
                                            <input
                                                type="checkbox"
                                                checked={formData.clan}
                                                onChange={() => roleManagementHandleCheckboxChange('clan')}
                                                className="custom-checkbox"
                                            />
                                            CLAN
                                        </label>

                                        <label className="flex items-center gap-2 text-[13px] cursor-pointer">
                                            <input
                                                checked={formData.sync}
                                                onChange={() => roleManagementHandleCheckboxChange('sync')}
                                                type="checkbox"
                                                className="custom-checkbox"
                                            />
                                            SYNC
                                        </label>
                                    </div>
                                </Form.Item>                    {/* Login Through */}
                                {(formData.darts || formData.clan) && (
                                    <div style={{ display: "flex", alignItems: "center", gap: "16px", marginTop: "4px" }}>
                                        <label style={{ fontSize: "13px", color: "#1C1B1F" }}>
                                            Login Through:<span style={{ color: "#AD0101", marginLeft: "4px" }}>*</span>
                                        </label>
                                        <Form.Item
                                            name="loginMethod"
                                            style={{ marginBottom: 0 }}
                                            rules={[{ required: true, message: 'Please select a login method!' }]}
                                        >
                                            <Radio.Group
                                                onChange={handleLoginMethodChange}
                                                value={formData.numberLogin ? "mobile" : formData.emailLogin ? "email" : ""}
                                            >
                                                <Radio value="mobile" className="custom-radio" style={{ fontSize: "13px" }}>Mobile</Radio>
                                                <Radio value="email" className="custom-radio" style={{ fontSize: "13px" }}>Email ID</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                    </div>
                                )}
                            </Form>
                        </Modal>
                    </div>
                )}
                <div className="self-registration-container">
                    <span className="self-registration-label">Self Registration</span>



                    <label className="toggle-switch">
                        <input
                            type="checkbox"
                            checked={isToggled}
                            onChange={handleToggle}
                        />
                        <span className="self-registration-slider"></span>
                    </label>
                </div>
                {accountId && (
                    <>
                        <div
                            className="row-container"
                            style={{
                                marginTop: "20px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <div
                                style={{
                                    fontWeight: "700",
                                    fontSize: "17px",
                                    color: "#1C1B1F",
                                    fontFamily: "Inter",
                                }}
                            >
                                Delete Client Data
                            </div>
                            <button className="deleteButton" onClick={() => setShowDeleteAccountModal(true)}>
                                Delete
                            </button>
                        </div>
                    </>
                )}
                {showdeleteAccountModal && (
                    <Modal
                        open={showdeleteAccountModal}
                        onCancel={() => setShowDeleteAccountModal(false)}
                        footer={null}
                        centered
                        width={500}
                        closable={false}
                    >
                        <p>
                            Do you want to delete this
                            <span style={{ fontWeight: "bold" }}> Account?</span>
                        </p>
                        <div className="delete-modal-footer">
                            <button
                                className="delete-account"
                                onClick={handleDelete}
                                disabled={deleteAccountLoading}
                            >
                                {deleteAccountLoading ? <span className="inline-block w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span> : "Delete"}
                            </button>
                            <button
                                className="delete-cancel"
                                onClick={() => setShowDeleteAccountModal(false)}
                            >
                                Cancel
                            </button>
                        </div>
                    </Modal>
                )}
                {accountId ? (
                    <div className="mt-8 flex justify-end gap-2">

                        <button
                            className="same-size-button same-size-button--outline"
                            onClick={handleDiscardClick}
                        >
                            Back
                        </button>

                        <button
                            className="same-size-button same-size-button--primary"
                            onClick={onFinish}
                            disabled={updateClientLoading}
                        >
                            {updateClientLoading ? (
                                <span className="inline-block w-2 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span>
                            ) : (
                                "Save"
                            )}
                        </button>

                    </div>
                ) : null}
                {!accountId ? (
                    <div className="mt-6 flex justify-end gap-4">

                        <button
                            className="same-size-button-discard "
                            onClick={handleDiscardClick}
                        >
                            Discard
                        </button>

                        <button
                            className="same-size-button-create"
                            onClick={handleSubmit}
                        >
                            Create
                        </button>

                    </div>) : null}
            </div>
        </Content >
    );
};
export default CreateClient;